import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../theme';
import { heightExtendingError, spaceBetween } from '../styles/mixins';

export const useReleaseShipmentPageStyles = createStyles(({ token }) => ({
  releaseShipmentPage: {
    '&&': {
      ...heightExtendingError(token),
    },
  },

  topRow: {
    '&&': {
      rowGap: ThemeSpaces.SPACE_NORM_20,
    },

    'h2.ant-typography': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      marginBottom: ThemeSpaces.SPACE_NORM,
      lineHeight: 1,

      [`@media (min-width: ${token.screenLGMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
        },
      [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
        {
          fontSize: token.fontSizeHeading4,
        },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        fontSize: token.fontSizeLG,
      },
    },

    '.label.size-full': {
      fontSize: ThemeFont.FONT_SIZE_XS,
      fontWeight: 500,
    },
  },

  topButtons: {
    display: 'flex',

    '> *': {
      ...spaceBetween(ThemeSpaces.SPACE_NORM),
    },

    '> .ant-btn': {
      width: 55,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
    '> .ant-btn.ant-btn-primary': {
      [`@media (min-width: ${token.screenLGMin}px)`]: {
        width: 120,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 100,
      },
      fontSize: token.fontSize,
    },
  },
}));
